<div><ng-content select="mat-card-title, mat-card-subtitle,
      [mat-card-title], [mat-card-subtitle],
      [matCardTitle], [matCardSubtitle]"></ng-content></div><ng-content select="img"></ng-content><ng-content></ng-content>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/card/typings/index.d.ts.MatCardTitleGroup.html